import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService, AppService, LocalStorageService } from '../../../../service';
import { Router } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController, PickerController } from '@ionic/angular';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi

import { PickerOptions } from "@ionic/core";

import { PersonSelectModalComponent } from '../person-select-modal/person-select-modal.component';
import { NewPageSelectComponent } from '../../../../shared/components/new-page-select/new-page-select.component';
import { LazyLoadingSelectComponent } from '../../../../shared/components/lazy-loading-select/lazy-loading-select.component';

import { FormSelectModalComponent } from '../form-select-modal/form-select-modal.component';
import { MultiSelectModalComponent } from '../../multi-select-modal/multi-select-modal.component';
import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { TranslateService } from '@ngx-translate/core';
import { OrgCascaderComponent } from '../../../../shared/components/org-cascader/org-cascader.component';

@Component({
  selector: 'total-filter-modal',
  templateUrl: './total-filter-modal.component.html',
  styleUrls: ['./total-filter-modal.component.scss'],
})
export class TotalFilterModalComponent implements OnInit {
  queryCriterias = [];
  query;
  // 默认筛选条件
  defaultBL = null;
  defaultDivision = null;
  defaultRegion = null;
  defaultProject = null;
  startTime = null;
  endTime = null;
  defaultCheckTable = null;
  courseType = null;
  maintanenceDept = null;
  needFormSelection;
  courseTypeList = [];
  courseTypeListTrans = [];
  maintenanceDeptList = [];
  maintenanceDeptListTrans = [];
  currentDateString = new Date().toISOString();
  workAreaList = [];
  // 选表的名字
  inspectionForm;
  // 选表要传递出的数据,第一个是type，第二个是id
  selectCheckTable = [];
  // 选表的数据源
  formPickerDate = [];
  queryCompany;
  isAction;
  queryForm;

  inspectionTaskStatusList = [];
  recordInspectionTypeMultiSelectStatusList = [];
  bbsoCorrectiveMultiSelectStatusList = [];
  observationStatusList = [];
  gmpFindStatusList = [];
  gmpFindingMultiSelectStatusList = [];
  gmpCnFindStatusList = [];
  activityStatusList = [];
  actionStatusList = [];
  actionTypeMultiSelectStatusList = [];
  inspectionMethodList = [];
  inspectionCategoryList = [];
  inspTypeList = [];
  gmpTypeList = [];
  gmpCorrectiveStatusList = []
  gmpCorrectiveMultiSelectStatusList = []
  noOrg;
  isHidden;
  isArea;
  isbbso;
  hasType;
  isGmpFinding;
  isGmpFindingMultiSelect;
  isGmpInspection;
  isGmpInspectionMultiSelect;
  gmpStatusList;
  isGmpCorrective;
  isGmpCorrectiveMultiSelect;
  isGmpCnInspection;
  isGmpCnCorrective;
  gmpCnInspectionCorrectiveStatusList = [];
  isRecordInspectionMultiSelect;
  isObservationMultiSelect;
  isBbsoCorrectiveMultiSelect;
  isHiddenMultiSelect;
  isActionMultiSelect;
  isInspectionSchedulinglistMultiSelect;
  gmpCnTaskTypeList;
  issueStatusList = [];
  isGmpCnFinding;
  inspectionLevelList = []
  drawingManagementList = [];
  selectedDrawingPlan;
  findingCategoryList = [];
  gmpRiskLevelList = [];
  gmpFindingClassificationList = [];
  isGmpCnDrawingMode;
  isRecordInspection;
  spaceOrg;
  rootSpaceList = [];
  // selectedRootSpace;
  isGMPRecordInspection;
  isGMPCustomizedInspection;
  customizedInspectionStatusList = [];

  constructor(
    public dataService: DataService,
    public appService: AppService,
    public router: Router,
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalController: ModalController,
    public localStorageService: LocalStorageService,
    public pickerController: PickerController,
    private translateService: TranslateService,
  ) {
    let params = this.navParams.data;
    this.query = params.query;
    this.isAction = params.isAction;
    this.isHidden = params.isHidden;
    this.isbbso = params.isbbso;
    this.noOrg = params.noOrg;
    this.isArea = params.isArea;
    this.hasType = params.hasType;
    this.isGmpFinding = params.isGmpFinding; //gmp发现列表
    this.isGmpFindingMultiSelect = params.isGmpFindingMultiSelect; // 普通GMP发现状态多选
    this.isGmpCnFinding = params.isGmpCnFinding;//中国大陆gmp发现列表
    this.isGmpInspection = params.isGmpInspection; //gmp审核列表
    this.isGmpInspectionMultiSelect = params.isGmpInspectionMultiSelect; // GMP检查状态多选
    this.isGmpCorrective = params.isGmpCorrective; //gmp整改列表
    this.isGmpCorrectiveMultiSelect = params.isGmpCorrectiveMultiSelect; // GMP整改状态多选
    this.isGmpCnCorrective = params.isGmpCnCorrective;//cnGMP整改状态多选
    this.isRecordInspection = params.isRecordInspection;
    this.isRecordInspectionMultiSelect = params.isRecordInspectionMultiSelect; // 普通检查状态多选
    this.isObservationMultiSelect = params.isObservationMultiSelect; // 观察记录状态多选
    this.isBbsoCorrectiveMultiSelect = params.isBbsoCorrectiveMultiSelect; // BBSO整改状态多选
    this.isHidden = params.isHidden;
    this.isHiddenMultiSelect = params.isHiddenMultiSelect; // 隐患状态多选
    this.isAction = params.isAction;
    this.isActionMultiSelect = params.isActionMultiSelect; // 普通整改状态多选
    this.isGmpCnInspection = params.isGmpCnInspection; //gmp检查整改列表
    this.isGmpCnDrawingMode = params.isGmpCnDrawingMode;  // gmp 检查 图纸模式
    this.selectedDrawingPlan = params.selectedDrawingPlan;  // gmp 检查 图纸
    this.isRecordInspection = params.isRecordInspection;
    this.isGMPRecordInspection = params.isGMPRecordInspection;
    this.isGMPCustomizedInspection = params.isGMPCustomizedInspection;
    this.isInspectionSchedulinglistMultiSelect = params.isInspectionSchedulinglistMultiSelect; // 检查计划状态多选
  }

  ngOnInit() {
    // 设置标题
    document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
    // 获取状态code
    this.getTaskStatusList();
    this.getInspTypeList();
    this.getInspectionCategoryList();
    this.loadDrawingManagementList();
    this.loadRootSpaceList();
    if (this.isGmpFinding) {
      this.getGmpRiskLevelList();
      this.getGmpFindingClassificationList();
    }
  }

  // 获取状态code
  async getTaskStatusList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_PL1,_SYS_GMP_AC,_SYS_GMP_AA,_SYS_AY,_SYS_BE').subscribe(res => {
        if (res && res.STATUS === 0) {
          const statusData = res.DATA.find(v => v.code == '_SYS_PL1').childCodes;
          const issueStatusData = res.DATA.find(v => v.code == '_SYS_BE');
          this.issueStatusList = issueStatusData && issueStatusData.childCodes ? issueStatusData.childCodes : [];
          const levelData = res.DATA.find(v => v.code == '_SYS_GMP_AC').childCodes;
          const questionData = res.DATA.find(v => v.code == '_SYS_GMP_AA').childCodes;
          const activityData = res.DATA.find(v => v.code == '_SYS_AY');
          if (activityData && activityData.childCodes) {
            const filterType0 = ['_SYS_AY_4', '_SYS_AY_5', '_SYS_AY_6', '_SYS_AY_7'];
            this.activityStatusList = activityData.childCodes.filter(child => filterType0.includes(child.code));
          }
          if (this.isbbso) {
            const filterType1 = ['_SYS_PL1_1', '_SYS_PL1_5', '_SYS_PL1_7'];
            this.inspectionTaskStatusList = statusData.filter(child => filterType1.includes(child.code));

            const filterType1b = ['_SYS_PL1_1', '_SYS_PL1_5', '_SYS_PL1_7', '_SYS_PL1_3'];
            this.bbsoCorrectiveMultiSelectStatusList = statusData.filter(child => filterType1b.includes(child.code));
          } else {
            const filterType2 = ['_SYS_PL1_8', '_SYS_PL1_1', '_SYS_PL1_I', '_SYS_PL1_E', '_SYS_PL1_7', '_SYS_PL1_3'];
            this.inspectionTaskStatusList = statusData.filter(child => filterType2.includes(child.code));
          }
          const filterType2b = ['_SYS_PL1_8', '_SYS_PL1_1', '_SYS_PL1_I', '_SYS_PL1_E', '_SYS_PL1_7', '_SYS_PL1_3', '_SYS_PL1_J'];
          this.recordInspectionTypeMultiSelectStatusList = statusData.filter(child => filterType2b.includes(child.code));

          const filterType4 = ['_SYS_PL1_7', '_SYS_PL1_8', '_SYS_PL1_1', '_SYS_PL1_I', '_SYS_PL1_E', '_SYS_PL1_3'];
          this.observationStatusList = statusData.filter(child => filterType4.includes(child.code));

          const filterType5 = ['_SYS_PL1_1', '_SYS_PL1_5', '_SYS_PL1_7'];
          this.actionStatusList = statusData.filter(child => filterType5.includes(child.code));

          const filterType5b = ['_SYS_PL1_1', '_SYS_PL1_5', '_SYS_PL1_7', '_SYS_PL1_3'];
          this.actionTypeMultiSelectStatusList = statusData.filter(child => filterType5b.includes(child.code));

          const filterType6 = ['_SYS_PL1_7', '_SYS_PL1_1', '_SYS_PL1_I', '_SYS_PL1_E', '_SYS_PL1_3'];
          this.gmpFindStatusList = statusData.filter(child => filterType6.includes(child.code));

          const filterType6b = ['_SYS_PL1_1', '_SYS_PL1_3', '_SYS_PL1_7', '_SYS_PL1_E'];
          this.gmpFindingMultiSelectStatusList = statusData.filter(child => filterType6b.includes(child.code));

          const filterType7 = ['_SYS_PL1_8', '_SYS_PL1_1', '_SYS_PL1_I', '_SYS_PL1_E', '_SYS_PL1_7', '_SYS_PL1_3', '_SYS_PL1_J', '_SYS_PL1_T2'];
          this.gmpStatusList = statusData.filter(child => filterType7.includes(child.code));


          const filterType8 = ['_SYS_PL1_1', '_SYS_PL1_3', '_SYS_PL1_5', '_SYS_PL1_7', '_SYS_PL1_I'];
          this.gmpCorrectiveStatusList = statusData.filter(child => filterType8.includes(child.code));

          const filterType8b = ['_SYS_PL1_1', '_SYS_PL1_5', '_SYS_PL1_7', '_SYS_PL1_I'];
          this.gmpCorrectiveMultiSelectStatusList = statusData.filter(child => filterType8b.includes(child.code));

          const filterType9 = ['_SYS_PL1_1', '_SYS_PL1_3', '_SYS_PL1_E', '_SYS_PL1_7', '_SYS_PL1_J', '_SYS_PL1_M','_SYS_PL1_I', '_SYS_PL1_8'];
          this.gmpCnFindStatusList = statusData.filter(child => filterType9.includes(child.code));

          const filterType10 = ['_SYS_PL1_8', '_SYS_PL1_7', '_SYS_PL1_E'];
          this.customizedInspectionStatusList = statusData.filter(child => filterType10.includes(child.code));

          const filterType11 = ['_SYS_PL1_1', '_SYS_PL1_3', '_SYS_PL1_5', '_SYS_PL1_7'];
          this.gmpCnInspectionCorrectiveStatusList = statusData.filter(child => filterType11.includes(child.code));

          this.inspectionLevelList = levelData
          this.findingCategoryList = questionData;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取类型type
  async getInspTypeList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_BS').subscribe(res => {
        if (res && res.STATUS === 0) {
          const filterType1 = ['_SYS_BS_C', '_SYS_BS_8', '_SYS_BS_B', '_SYS_BS_9'];
          this.inspTypeList = res.DATA[0].childCodes.filter(child => filterType1.includes(child.code));
          const filterType2 = ['_SYS_BS_9', '_SYS_BS_10'];
          this.inspectionMethodList = res.DATA[0].childCodes.filter(child => filterType2.includes(child.code));

          const filterType3 = ['_SYS_BS_11', '_SYS_BS_12'];
          this.gmpTypeList = res.DATA[0].childCodes.filter(child => filterType3.includes(child.code));

          const filterType4 = ['_SYS_BS_13', '_SYS_BS_14'];
          this.gmpCnTaskTypeList = res.DATA[0].childCodes.filter(child => filterType4.includes(child.code));
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  async getInspectionCategoryList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_IC').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.inspectionCategoryList = res.DATA && res.DATA[0] ? res.DATA[0].childCodes : [];
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 重置条件
  resetSearchFilters() {
    Object.keys(this.query).forEach((item, index) => {
      this.query[item] = null;
    });
  }

  cancel() {
    this.modalController.dismiss();
  }

  confirm() {
    // console.log(this.query.type);
    this.modalController.dismiss({ query: this.query, selectedDrawingPlan: this.selectedDrawingPlan });
  }

  async selectOrg() {
    history.pushState(null, null, document.URL);
    let needBusinessScope = false;
    if (this.isGMPRecordInspection || this.isGmpCnFinding || this.isGmpCnInspection) {
      needBusinessScope = true;
    }

    const modal = await this.modalController.create({
      component: OrgCascaderComponent,
      componentProps: {
        selected: this.query.businessLine,
        businessScope: needBusinessScope ? '_SYS_SCOPE_1,_SYS_SCOPE_2' : null
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.businessLine = res.data;
        this.getWorkTypeClassification()
      }
    });
    return await modal.present();
  }

  // 更新开始时间格式
  changeStartTimeFormat(event) {
    let selectedDate = event.detail.value;
    if (selectedDate) {
      if (this.endTime && new Date(selectedDate).getTime() - new Date(this.endTime).getTime() > 0) {
        this.appService.toastTip('shared_components.filter_modals.start_time_not_lg_end_time', true);
      } else {
        this.startTime = new Date(selectedDate).toISOString();
      }
    }
  }
  // 更新结束时间格式
  changeEndTimeFormat(event) {
    let selectedDate = event.detail.value;
    if (selectedDate) {
      if (this.startTime && new Date(selectedDate).getTime() - new Date(this.startTime).getTime() < 0) {
        this.appService.toastTip('shared_components.filter_modals.end_time_not_lg_start_time', true);
      } else {
        this.endTime = new Date(selectedDate).toISOString();
      }
    }
  }

  // 检查层级
  async selectInspectionLevel() {
    let i = 0;
    if (this.query.inspectionLevel) {
      this.inspectionLevelList.forEach((res, index) => {
        if (res.code === this.query.inspectionLevel) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.inspectionLevel = value.inspectionLevel.value;
          }
        }
      ],
      columns: [
        {
          name: 'inspectionLevel',
          options: this.getOptionListOfTranslate(this.inspectionLevelList),
          selectedIndex: i
        }
      ]
    };
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  // 检查方式
  async selectInspectionMethod() {
    let i = 0;
    if (this.query.inspectionMethod) {
      this.inspectionMethodList.forEach((res, index) => {
        if (res.code === this.query.inspectionMethod) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.inspectionMethod = value.inspectionMethod.value;
          }
        }
      ],
      columns: [
        {
          name: 'inspectionMethod',
          options: this.getOptionListOfTranslate(this.inspectionMethodList),
          selectedIndex: i
        }
      ]
    };
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  async selectInspectionCategory() {
    let i = 0;
    if (this.query.checkCategory) {
      this.inspectionCategoryList.forEach((res, index) => {
        if (res.code === this.query.checkCategory) {
          i = index;
          return;
        }
      });
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.checkCategory = value.checkCategory.value;
          }
        }
      ],
      columns: [
        {
          name: 'checkCategory',
          options: this.getOptionListOfTranslate(this.inspectionCategoryList),
          selectedIndex: i
        }
      ]
    };
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  // 审核类型
  async selectAuditType() {
    const modal = await this.modalController.create({
      component: MultiSelectModalComponent,
      showBackdrop: true,
      backdropDismiss: true,
      componentProps: {
        code: '_SYS_BL',
        selectedOptions: this.query.inspectionCategory,
        modalTitle: this.translateService.instant('shared_components.filter_modals.audit_type_display_key'),
        inspectionEHS: true
      }
    });
    modal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.filter_modals.audit_type_display_key');
      if (res.data) {
        this.query.inspectionCategory = res.data.selectedOptions;
      }
    });
    return await modal.present();
  }

  // 将查询到的code转化为下拉组件可以识别的形式
  getOptionListOfTranslate(list) {
    let options = [];
    list.forEach(item => {
      let lang = localStorage.getItem("APP_LANG");
      switch (lang) {
        case 'zh_CN':
          options.push({ text: item.code_desc_zh, value: item.code });
          break;
        case 'en_US':
          options.push({ text: item.code_desc_en, value: item.code });
          break;
        case 'zh_TW':
          options.push({ text: item.code_desc_tr, value: item.code });
          break;
        case 'vi':
          options.push({ text: item.code_desc_vi, value: item.code });
          break;
        case 'km':
          options.push({ text: item.code_desc_km, value: item.code });
          break;
        case 'th':
          options.push({ text: item.code_desc_th, value: item.code });
          break;
        case 'lo':
          options.push({ text: item.code_desc_lo, value: item.code });
          break;
        default:
          options.push({ text: item.code_desc_en, value: item.code });
          break;
      }
    });
    return options;
  }

  private getMultiSelectDisplayField(): string {
    const lang = this.localStorageService.getStore('APP_LANG');
    switch (lang) {
      case 'zh_CN': return 'code_desc_zh';
      case 'zh_TW': return 'code_desc_tr';
      case 'en_US': return 'code_desc_en';
      case 'vi': return 'code_desc_vi';
      case 'km': return 'code_desc_km';
      case 'th': return 'code_desc_th';
      case 'lo': return 'code_desc_lo';
      default: return 'code_desc_zh';
    }
  }

  private async openMultiStatusModal(statusList: any[]) {
    return this.openMultiCodeModal('status', statusList, 'shared_components.common.status');
  }

  private async openMultiCodeModal(field: string, optionList: any[], titleKey: string) {
    history.pushState(null, null, document.URL);
    const pageTitle = this.translateService.instant(titleKey);
    const statusModal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle,
        placeholderMessage: pageTitle,
        optionList,
        displayField: this.getMultiSelectDisplayField(),
        valueField: 'code',
        multiSelect: true,
        needFilterSearch: false,
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query[field] ? String(this.query[field]).split(',').filter(Boolean) : [],
      },
      showBackdrop: true,
      backdropDismiss: true
    });

    statusModal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (Array.isArray(res.data)) {
        this.query[field] = res.data.length > 0 ? res.data.join(',') : null;
      }
    });
    return await statusModal.present();
  }

  async getGmpRiskLevelList(): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      this.dataService.codesChildrenOf('_SYS_RR').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.gmpRiskLevelList = res.DATA[0] && res.DATA[0].childCodes ? res.DATA[0].childCodes : [];
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
  }

  async getGmpFindingClassificationList(): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      this.dataService.codesChildrenOf('_SYS_FC').subscribe(res => {
        if (res && res.STATUS === 0) {
          const data = res.DATA[0] && res.DATA[0].childCodes ? res.DATA[0].childCodes : [];
          const tempArr = [];
          data.forEach(item => {
            if (item.childCodes && item.childCodes.length) {
              tempArr.push(...item.childCodes);
            } else {
              tempArr.push(item);
            }
          });
          this.gmpFindingClassificationList = tempArr;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
  }

  async selectRiskLevel() {
    return this.openMultiCodeModal(
      'riskLevel',
      this.gmpRiskLevelList,
      'gmp.add_find_detail.inspection_risk_level'
    );
  }

  async selectClassification() {
    return this.openMultiCodeModal(
      'classification',
      this.gmpFindingClassificationList,
      'shared_components.filter_modals.inspection_finding_category'
    );
  }

  async selectTaskStatus() {
    if (this.isGmpCorrective) {
      if (this.isGmpCorrectiveMultiSelect) {
        return this.openMultiStatusModal(this.gmpCorrectiveMultiSelectStatusList);
      }

      let i = 0;
      if (this.query.status && Array.isArray(this.query.status)) {
        this.query.status.forEach((res, index) => {
          if (res.code === this.query.status) {
            i = index;
            return;
          }
        })
      }
      let options: PickerOptions = {
        buttons: [
          {
            text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
            role: 'cancel'
          },
          {
            text: this.translateService.instant('common.confirm'),
            handler: (value: any) => {
              this.query.status = value.severity.value;
            }
          }
        ],
        columns: [
          {
            name: 'severity',
            options: this.getOptionListOfTranslate(this.gmpCorrectiveStatusList),
            selectedIndex: i
          }
        ]
      };

      let picker = await this.pickerController.create(options);
      return picker.present();
    } else if (this.isGmpInspection) {
      if (this.isGmpInspectionMultiSelect) {
        return this.openMultiStatusModal(this.gmpStatusList);
      }

      let i = 0;
      if (this.query.status && Array.isArray(this.query.status)) {
        this.query.status.forEach((res, index) => {
          if (res.code === this.query.status) {
            i = index;
            return;
          }
        })
      }
      let options: PickerOptions = {
        buttons: [
          {
            text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
            role: 'cancel'
          },
          {
            text: this.translateService.instant('common.confirm'),
            handler: (value: any) => {
              this.query.status = value.severity.value;
            }
          }
        ],
        columns: [
          {
            name: 'severity',
            options: this.getOptionListOfTranslate(this.gmpStatusList),
            selectedIndex: i
          }
        ]
      };

      let picker = await this.pickerController.create(options);
      return picker.present();
    } else if (this.isGmpFinding) {
      if (this.isGmpFindingMultiSelect) {
        return this.openMultiStatusModal(this.gmpFindingMultiSelectStatusList);
      }

      let i = 0;
      if (this.query.status && Array.isArray(this.query.status)) {
        this.query.status.forEach((res, index) => {
          if (res.code === this.query.status) {
            i = index;
            return;
          }
        })
      }
      let options: PickerOptions = {
        buttons: [
          {
            text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
            role: 'cancel'
          },
          {
            text: this.translateService.instant('common.confirm'),
            handler: (value: any) => {
              this.query.status = value.severity.value;
            }
          }
        ],
        columns: [
          {
            name: 'severity',
            options: this.getOptionListOfTranslate(this.gmpFindStatusList),
            selectedIndex: i
          }
        ]
      };

      let picker = await this.pickerController.create(options);
      return picker.present();
    } else if (this.isGmpFinding) {
      let i = 0;
      if (this.query.status && Array.isArray(this.query.status)) {
        this.query.status.forEach((res, index) => {
          if (res.code === this.query.status) {
            i = index;
            return;
          }
        })
      }
      let options: PickerOptions = {
        buttons: [
          {
            text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
            role: 'cancel'
          },
          {
            text: this.translateService.instant('common.confirm'),
            handler: (value: any) => {
              this.query.status = value.severity.value;
            }
          }
        ],
        columns: [
          {
            name: 'severity',
            options: this.getOptionListOfTranslate(this.gmpFindStatusList),
            selectedIndex: i
          }
        ]
      };

      let picker = await this.pickerController.create(options);
      return picker.present();
    } else if (this.isGmpCnInspection && this.isGmpCnCorrective) {
      return this.openMultiStatusModal(
        this.gmpCnInspectionCorrectiveStatusList
      );
    } else if (this.isGmpCnCorrective) {
      return this.openMultiStatusModal(
        this.gmpCnInspectionCorrectiveStatusList
      );
    } else if (this.isGmpCnInspection) {
      let i = 0;
      if (this.query.status && Array.isArray(this.query.status)) {
        this.query.status.forEach((res, index) => {
          if (res.code === this.query.status) {
            i = index;
            return;
          }
        })
      }
      let options: PickerOptions = {
        buttons: [
          {
            text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
            role: 'cancel'
          },
          {
            text: this.translateService.instant('common.confirm'),
            handler: (value: any) => {
              this.query.status = value.severity.value;
            }
          }
        ],
        columns: [
          {
            name: 'severity',
            options: this.getOptionListOfTranslate(this.observationStatusList),
            selectedIndex: i
          }
        ]
      };

      let picker = await this.pickerController.create(options);
      return picker.present();
    } else if (this.isArea) {
      if (this.isObservationMultiSelect) {
        return this.openMultiStatusModal(this.observationStatusList);
      }

      let i = 0;
      if (this.query.status && Array.isArray(this.query.status)) {
        this.query.status.forEach((res, index) => {
          if (res.code === this.query.status) {
            i = index;
            return;
          }
        })
      }
      let options: PickerOptions = {
        buttons: [
          {
            text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
            role: 'cancel'
          },
          {
            text: this.translateService.instant('common.confirm'),
            handler: (value: any) => {
              this.query.status = value.severity.value;
            }
          }
        ],
        columns: [
          {
            name: 'severity',
            options: this.getOptionListOfTranslate(this.observationStatusList),
            selectedIndex: i
          }
        ]
      };

      let picker = await this.pickerController.create(options);
      return picker.present();
    } else if (this.isHidden) {
      if (this.isHiddenMultiSelect) {
        return this.openMultiStatusModal(this.issueStatusList);
      }

      const modal = await this.modalController.create({
        component: MultiSelectModalComponent,
        showBackdrop: true,
        backdropDismiss: true,
        componentProps: {
          code: '_SYS_BE',
          selectedOptions: this.query.status,
          modalTitle: this.translateService.instant('shared_components.common.status'),
          issueStatus: true,
        }
      });
      modal.onDidDismiss().then(res => {
        document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
        if (res.data) {
          this.query.status = res.data.selectedOptions;
        }
      });
      return await modal.present();
    } else if (this.isGmpCnFinding) {
      return this.openMultiStatusModal(this.gmpCnFindStatusList);
    } else if (this.isBbsoCorrectiveMultiSelect) {
      if (this.isbbso) {
        return this.openMultiStatusModal(this.bbsoCorrectiveMultiSelectStatusList);
      }
      return this.openMultiStatusModal(this.inspectionTaskStatusList);
    } else if (this.isGMPCustomizedInspection) {
      return this.openMultiStatusModal(this.customizedInspectionStatusList);
    } else if (this.isGMPRecordInspection) {
      if (this.isInspectionSchedulinglistMultiSelect) {
        return this.openMultiStatusModal(this.activityStatusList);
      }

      let i = 0;
      if (this.query.status) {
        this.activityStatusList.forEach((res, index) => {
          if (res.code === this.query.status) {
            i = index;
            return;
          }
        });
      }
      let options: PickerOptions = {
        buttons: [
          {
            text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
            role: 'cancel'
          },
          {
            text: this.translateService.instant('common.confirm'),
            handler: (value: any) => {
              this.query.status = value.taskStatus.value;
            }
          }
        ],
        columns: [
          {
            name: 'taskStatus',
            options: this.getOptionListOfTranslate(this.activityStatusList),
            selectedIndex: i
          }
        ]
      };

      let picker = await this.pickerController.create(options);
      return picker.present();
    } else {
      if (this.isRecordInspectionMultiSelect) {
        if (this.hasType && this.isRecordInspection) {
          return this.openMultiStatusModal(this.recordInspectionTypeMultiSelectStatusList);
        }
        return this.openMultiStatusModal(this.inspectionTaskStatusList);
      }
      if (this.isActionMultiSelect) {
        if (this.hasType && this.isAction) {
          return this.openMultiStatusModal(this.actionTypeMultiSelectStatusList);
        }
        return this.openMultiStatusModal(this.actionStatusList);
      }
      if (this.isAction) {
        this.inspectionTaskStatusList = this.actionStatusList;
      }
      let i = 0;
      if (this.query.status) {
        this.inspectionTaskStatusList.forEach((res, index) => {
          if (res.code === this.query.status) {
            i = index;
            return;
          }
        })
      }
      let options: PickerOptions = {
        buttons: [
          {
            text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
            role: 'cancel'
          },
          {
            text: this.translateService.instant('common.confirm'),
            handler: (value: any) => {
              this.query.status = value.taskStatus.value;
            }
          }
        ],
        columns: [
          {
            name: 'taskStatus',
            options: this.getOptionListOfTranslate(this.inspectionTaskStatusList),
            selectedIndex: i
          }
        ]
      };

      let picker = await this.pickerController.create(options);
      return picker.present();
    }
  }

  async selectTypeStatus() {
    let i = 0;
    if (this.query.type) {
      if (this.isGmpInspection || this.isGmpCorrective) {
        this.gmpTypeList.forEach((res, index) => {
          if (res.code === this.query.type) {
            i = index;
            return;
          }
        })
      } else if (this.isGmpCnInspection) {
        this.gmpCnTaskTypeList.forEach((res, index) => {
          if (res.code === this.query.type) {
            i = index;
            return;
          }
        })
      } else {
        this.inspTypeList.forEach((res, index) => {
          if (res.code === this.query.type) {
            i = index;
            return;
          }
        })
      }

    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.type = value.typeObj.value;
          }
        }
      ],
      columns: [
        {
          name: 'typeObj',
          options: this.getOptionListOfTranslate((this.isGmpInspection || this.isGmpCorrective) ? this.gmpTypeList : ((this.isGmpCnInspection || this.isGmpCnFinding) ? this.gmpCnTaskTypeList : this.inspTypeList)),
          selectedIndex: i
        }
      ]
    };

    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  async selectWorkingArea() {
    if (!this.query.businessLine) {
      this.appService.toastTip('shared_components.filter_modals.select_upper_org_structure', true);
      return;
    };
    let i = 0;
    console.log(this.query);
    if (this.query.workArea) {
      this.workAreaList.forEach((res, index) => {
        if (res.code === this.query.workArea) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.workArea = value.workAreaFilter.value;
          }
        }
      ],
      columns: [
        {
          name: 'workAreaFilter',
          options: this.getWorkTypeStatusOptionList(),
          selectedIndex: i
        }
      ]
    };

    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  getMultiStatusTranslationList(): any[] {
    if (this.isInspectionSchedulinglistMultiSelect) {
      return this.activityStatusList;
    }
    if (this.isGmpCnFinding) {
      return this.gmpCnFindStatusList;
    }
    if (this.isGmpCnCorrective) {
      return this.gmpCnInspectionCorrectiveStatusList;
    }
    if (this.isGmpFindingMultiSelect) {
      return this.gmpFindingMultiSelectStatusList;
    }
    if (this.isGmpInspectionMultiSelect) {
      return this.gmpStatusList;
    }
    if (this.isGmpCorrectiveMultiSelect) {
      return this.gmpCorrectiveMultiSelectStatusList;
    }
    if (this.isRecordInspectionMultiSelect) {
      if (this.hasType && this.isRecordInspection) {
        return this.recordInspectionTypeMultiSelectStatusList;
      }
      return this.inspectionTaskStatusList;
    }
    if (this.isObservationMultiSelect) {
      return this.observationStatusList;
    }
    if (this.isBbsoCorrectiveMultiSelect) {
      if (this.isbbso) {
        return this.bbsoCorrectiveMultiSelectStatusList;
      }
      return this.inspectionTaskStatusList;
    }
    if (this.isHiddenMultiSelect) {
      return this.issueStatusList;
    }
    if (this.isActionMultiSelect) {
      if (this.hasType && this.isAction) {
        return this.actionTypeMultiSelectStatusList;
      }
      return this.actionStatusList;
    }
    return [];
  }

  translateStatusCodes(status: string, translationList: any[] = this.gmpCnFindStatusList): string {
    if (!status) return '';
    return String(status).split(',')
      .map(code => this.translateCode(code, translationList))
      .filter(name => name)
      .join(', ');
  }

  translateCode(code, translationList: any[]) {
    let lang = this.localStorageService.getStore("APP_LANG");
    let data = null;
    for (const item of translationList) {
      if (code === item.code) {
        switch (lang) {
          case 'zh_CN':
            data = item.code_desc_zh;
            break;
          case 'zh_TW':
            data = item.code_desc_tr;
            break;
          case 'en_US':
            data = item.code_desc_en;
            break;
          case 'vi':
            data = item.code_desc_vi;
            break;
          case 'km':
            data = item.code_desc_km;
            break;
          case 'th':
            data = item.code_desc_th;
            break;
          case 'lo':
            data = item.code_desc_lo;
            break;
        }
        return data ? data : item.code_desc_zh;
      }
    }
    return '';
  }

  getWorkTypeStatusOptionList() {
    let options = [];
    this.workAreaList.forEach(item => {
      options.push({ text: item.spaceName, value: item.id });
    });
    return options;
  }

  translateCodeArea(id, dataList: any[]) {
    for (const item of dataList) {
      if (id === item.id) {
        return item.spaceName;
      }
    }
    return '';
  }

  getWorkTypeClassification() {
    const param = {
      pagingTool: {
        currentPage: 1,
        pageSize: 100
      },
      queryCriterias: [{
        condition: "=",
        connection: "and",
        isValueADigital: false,
        key: "es.org_id",
        value: this.query.businessLine.id
      }],
      queryOrderBies: [{
        columnName: "id",
        orderType: "desc"
      }]
    };
    this.dataService.getSpaceList(param).subscribe(res => {
      if (res && res['STATUS'] === 0) {
        this.workAreaList = res['DATA'];
      }
    });
  }
  employeeProcess(emp) {
    if (emp) {
      return '[' + emp.code + '] ' + emp.full_name;
    }
    return;
  }

  formProcess(form) {
    if (form) {
      return form.formName;
    }
    return;
  }

  // async selectInspector(selectedPerson) {
  //   const modal = await this.modalController.create({
  //     component: PersonSelectModalComponent,
  //     showBackdrop: true,
  //     backdropDismiss: true,
  //     componentProps: {
  //       selectPerson: selectedPerson,
  //       modalTitle: this.translateService.instant('shared_components.common.inspector'),
  //       source: 'auto',
  //     }
  //   });
  //   modal.onDidDismiss().then(res => {
  //     // 允许通过点击背景关闭模态框
  //     document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
  //     if (res.data) {
  //       this.query.inspector = res.data.person;
  //     }
  //   });
  //   return await modal.present();
  // }

  async selectInspector(selectedPerson) {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: LazyLoadingSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.common.inspector'),
        placeholderMessage: this.translateService.instant('shared_components.common.inspector'),
        originalOptionList: [],
        displayField: ['code', 'full_name'],
        valueField: '$self',
        multiSelect: false,
        format: '[$1] $2',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: selectedPerson,
        isStaff: true,
        searchData: [],
        includeUser: true, // 选人过滤没有登陆信息的
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.inspector = res.data;
      }
    });
    return await modal.present();
  }

  

  // async selectReporter(selectedPerson) {
  //   const modal = await this.modalController.create({
  //     component: PersonSelectModalComponent,
  //     showBackdrop: true,
  //     backdropDismiss: true,
  //     componentProps: {
  //       selectPerson: selectedPerson,
  //       peopleInOrgId: this.query.spaceOrg ? this.query.spaceOrg.id : null,
  //       modalTitle: this.translateService.instant('shared_components.filter_modals.submit_person'),
  //       source: 'auto',
  //     }
  //   });
  //   modal.onDidDismiss().then(res => {
  //     document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
  //     if (res.data) {
  //       this.query.createdBy = res.data.person;
  //     }
  //   });
  //   return await modal.present();
  // }

  async selectReporter(selectedPerson) {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: LazyLoadingSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.submit_person'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.submit_person'),
        originalOptionList: [],
        displayField: ['code', 'full_name'],
        valueField: '$self',
        multiSelect: false,
        format: '[$1] $2',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: selectedPerson,
        isStaff: true,
        searchData: [],
        includeUser: true, // 选人过滤没有登陆信息的
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.createdBy = res.data;
      }
    });
    return await modal.present();
  }


  // async selectSpaceOrg() {
  //   history.pushState(null, null, document.URL);
  //   const modal = await this.modalController.create({
  //     component: OrgCascaderComponent,
  //     componentProps: {
  //       selected: this.query.spaceOrg ? this.query.spaceOrg : null,
  //       businessScope: '_SYS_SCOPE_1,_SYS_SCOPE_2'
  //     },
  //     showBackdrop: true,
  //     backdropDismiss: true
  //   });
  //   modal.onDidDismiss().then(res => {
  //     document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
  //     if (res.data) {
  //       this.query.spaceOrg = res.data;
  //       this.query.spaceOrgId = res.data.id;
  //     }
  //   });
  //   return await modal.present();
  // }

  async selectDepartment() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: LazyLoadingSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.reporting_department'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.reporting_department'),
        originalOptionList: [],
        displayField: ['code', 'full_name'],
        valueField: '$self',
        multiSelect: false,
        format: '[$1] $2',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.spaceOrg,
        isOrg: true,
        businessScope: '_SYS_SCOPE_1,_SYS_SCOPE_2'
        // searchData: staffData,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.spaceOrg = res.data;
        this.query.spaceOrgId = res.data.id;
      }
    });
    return await modal.present();
  }


  // 选择表格
  async selectForm(selectedForm) {
    const modal = await this.modalController.create({
      component: FormSelectModalComponent,
      showBackdrop: true,
      backdropDismiss: true,
      componentProps: {
        selectedForm: selectedForm,
        modalTitle: this.translateService.instant('shared_components.filter_modals.check_table_table'),
        excludeMedical: true,
      }
    });
    modal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.formSelector = res.data.form;
      }
    });
    return await modal.present();
  }
  // 获取当前组织架构下的平面图
  loadDrawingManagementList() {
    const param = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [{
        "connection": "and",
        "key": "status",
        "condition": "=",
        "value": '_SYS_A9_1',
        "isValueADigital": false
      }],
      queryOrderBies: [{
        columnName: 'code',
        orderType: 'ASC'
      }]
    };
    if (this.query.businessLine) {
      param.queryCriterias.push({
        "connection": "and",
        "key": "egd.org_id",
        "condition": "=",
        "value": this.query.businessLine.id,
        "isValueADigital": false
      })
    }
    this.dataService.gmpDrawingManagementList(param).subscribe(res => {
      if (res && res.STATUS == 0) {
        this.drawingManagementList = res.DATA

      }
    })
  }
  // 平面图
  async selectFloorPlan() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.common.map_point'),
        placeholderMessage: this.translateService.instant('shared_components.common.map_point'),
        originalOptionList: this.drawingManagementList,
        displayField: ['code', 'name'],
        valueField: '$self',
        multiSelect: false,
        format: '[$1] $2',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.selectedDrawingPlan,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('inspection.inspectionActivity.issueReporting');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('inspection.inspectionActivity.issueReporting') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.selectedDrawingPlan = res.data;
        this.query.drawingId = res.data.id;
      }
    });
    return await modal.present();
  }

  // 获取当前组织架构下的根空间列表
  loadRootSpaceList() {
    const param = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [{
        "connection": "and",
        "key": "rootSpace",
        "condition": "=",
        "value": true,
        "isValueADigital": false
      }],
      queryOrderBies: [{
        columnName: 'code',
        orderType: 'ASC'
      }]
    };
    // if (this.query.businessLine) {
    //   param.queryCriterias.push({
    //     "connection": "and",
    //     "key": "egd.org_id",
    //     "condition": "=",
    //     "value": this.query.businessLine.id,
    //     "isValueADigital": false
    //   })
    // }
    this.dataService.getGMPSpaceList(param).subscribe(res => {
      if (res && res.STATUS == 0) {
        this.rootSpaceList = res.DATA
      }
    })
  }

  // 责任部门
  async selectResponsibilityZone() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.common.map_point'),
        placeholderMessage: this.translateService.instant('shared_components.common.map_point'),
        originalOptionList: this.rootSpaceList,
        displayField: ['serialNumber', 'spaceName'],
        valueField: '$self',
        multiSelect: false,
        format: '[$1] $2',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.rootSpace,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('inspection.inspectionActivity.issueReporting');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('inspection.inspectionActivity.issueReporting') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        // this.selectedRootSpace = res.data;
        this.query.rootSpaceId = res.data.id;
        this.query.rootSpace = res.data;
      }
    });
    return await modal.present();
  }

  getTranslateCode(str) {
    let trans = '';
    if (str) {
      const codes = str.split(',');
      codes.forEach((code, index) => {
        trans += this.translateService.instant(code);
        if (index !== codes.length - 1) {
          trans += ',';
        }
      });
    }
    return trans;
  }

   // 发现分类
  async selectFindingCategory() {
    history.pushState(null, null, document.URL);
    var lang = localStorage.getItem("APP_LANG");
    var display_field = 'code_desc_zh';
    switch (lang) {
      case 'en_US':
        display_field = 'code_desc_en';
        break;
      case 'zh_TW':
        display_field = 'code_desc_tr';
        break;
      case 'vi':
        display_field = 'code_desc_vi';
        break;
      case 'km':
        display_field = 'code_desc_km';
        break;
      default:
        display_field = 'code_desc_zh';
        break;
    }
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.inspection_finding_category'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.inspection_finding_category'),
        originalOptionList: this.findingCategoryList,
        displayField: display_field,
        valueField: 'code',
        multiSelect: false,
        needTranslation: false,
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.questionName ? this.query.questionName : [],
        needShowColor: true
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.filter_modals.inspection_finding_category');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.filter_modals.inspection_finding_category') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.questionName = res.data;
      }
    });
    return await modal.present();
  }
}
